import { j as r } from "./kezios-design-system.esm172.js";
import { Modal as m, Stack as x, Text as p } from "@mantine/core";
import j from "./kezios-design-system.esm175.js";
import { Spacing as u } from "./kezios-design-system.esm135.js";
const C = ({
  opened: t,
  onClose: s,
  title: o,
  titleProps: a,
  Icon: i,
  children: l,
  withWaves: n = !0,
  ...c
}) => {
  const d = n ? 5 : 0;
  return /* @__PURE__ */ r.jsx(
    m,
    {
      opened: t,
      onClose: s,
      withCloseButton: !0,
      title: /* @__PURE__ */ r.jsxs("div", { style: { position: "relative" }, children: [
        [...Array(d)].map((v, e) => /* @__PURE__ */ r.jsx(
          "div",
          {
            className: j.circle,
            style: {
              "--index": e
            }
          },
          e
        )),
        i
      ] }),
      ...c,
      children: /* @__PURE__ */ r.jsx(h, { title: o, titleProps: a, children: l })
    }
  );
}, h = ({
  title: t,
  children: s,
  titleProps: o
}) => /* @__PURE__ */ r.jsxs(x, { gap: u.s6, children: [
  t && /* @__PURE__ */ r.jsx(p, { variant: "textLg.semibold", c: "gray.9", ...o, children: t }),
  s
] });
export {
  C as Modal,
  h as ModalCard
};
